// extracted by mini-css-extract-plugin
export default {"title":"About_title__ppWdx","list":"About_list__tMc++","list__item":"About_list__item__FpV6w","comment":"About_comment__P1Piu","showComment":"About_showComment__LB7wa"};